import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import CalculatorApp from "./CalculatorApp";
createRoot(document.getElementById("root")).render(_jsx(CalculatorApp, {}));
